var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{key:_vm.componentKey,attrs:{"align-h":"center","align":"center"}},[_c('b-col',{attrs:{"xs":"12","sm":"12","md":"6","lg":"3","xl":"3"}},[_c('b-tabs',[_c('p')])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }